import { render, staticRenderFns } from "./MainCenter.vue?vue&type=template&id=88e1fafe&"
import script from "./MainCenter.vue?vue&type=script&lang=js&"
export * from "./MainCenter.vue?vue&type=script&lang=js&"
import style0 from "./MainCenter.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports